import React, { useEffect, useState } from 'react'
import { Link, useHistory, useLocation, useParams } from 'react-router-dom'
import { toast } from 'react-toastify';
import { AddBox } from '@mui/icons-material';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { FetchApi } from '../../../api/fetch';
import Button from '../../../components/Button'
import { ENDPOINT, GO_DE_GQL_BACKEND_URL } from '../../../constants'
import { useAuth } from '../../../contexts/AuthContext'
import CourseCard from '../../../components/CourseCard';
import { InputField } from '../../../components/InputField';
import BtnGradient from '../../../components/GradientButton';
import { QUERY_COURSES } from './query';



interface ICourse {
   updatedAt: string;
   subCategoryIds: string[];
   startDate: string;
   projectWebsite: string;
   projectName: string;
   numberOfTicketAward: number;
   name: string;
   maxAttendees: number;
   id: string;
   logoURL: string;
   endDate: string;
   description: string;
   createdAt: string;
   bannerURL: string;
   categoryIds: string[];
   position: number;
}
function Courses() {
   const { setIsLoadingOverlayDisplay, getUserJWT } = useAuth()
   const [courses, setCourses] = useState<ICourse[]>([])
   const { state }: any = useLocation();
   const { push } = useHistory()
   const { category, sub }: any = useParams()

   useEffect(() => {
      // getFeatured()
      getCourses()
   }, [])


   const handleSearch = async (e: any) => {
      if (e.target.value?.length > 3) {
         getCourses(e.target.value)
      }
   }
   const getCourses = async (name?: string) => {
      if (!state) {
         push("/dashboard/course-categories")
      }
      if (!name) {
         setIsLoadingOverlayDisplay(true)
      }

      try {
         const cat = await FetchApi({
            endpoint: GO_DE_GQL_BACKEND_URL,
            method: "POST",
            body:  ({
               query: QUERY_COURSES,
               variables: { subCategoryId: state.id, name: name }
            })
         })
         const sorted = cat?.data?.course?.nodes?.sort((a: any, b: any) => a?.position - b?.position)
         setCourses(sorted)
      } catch (error) {
         // :TODO
         // add error toast
         console.log(error);

      }
      setIsLoadingOverlayDisplay(false)

   }


   const onDragEnd = (result: any) => {
      // dropped outside the list
      if (!result.destination) {
         return;
      }
      const newItems = [...courses];
      const [reordered] = newItems.splice(result.source.index, 1);
      newItems.splice(result.destination.index, 0, reordered);
      setCourses(newItems)
      saveEntry(reordered, result.destination.index + 1)
   }

   const saveEntry = async (course: any, pos: number) => {
      const userJWT = await getUserJWT()

      const reqBody = {
         id: course.id,
         name: course.name,
         description: course.description,
         project_name: course.projectName,
         project_website: course.projectWebsite,
         number_of_ticket_award: course.numberOfTicketAward,
         max_attendees: course.maxAttendees,
         start_date: course.startDate,
         end_date: course.endDate,
         logo_url: course.logoURL,
         banner_url: course.bannerURL,
         position: pos,
         featured_position: course.featuredPosition,
         category_id: course.categoryIds,
         sub_category_id: course.subCategoryIds,
         is_featured: course.isFeatured,
         no_max_attendees: course.noMaxAttendees,
         no_expiry: course.noExpiry,
         time_required: course.timeRequired
      }

      try {
         const data = await FetchApi({
            endpoint: ENDPOINT.BASE_ENDPOINT_ACADEMY + `/${course.id}/edit-course`,
            method: `${'PATCH'}`,
            JWT: userJWT,
            body:  (reqBody)
         })


         if (data) {
            toast.success(data.message)
         }

      } catch (error: any) {
         toast.error(error.message)
      }

   }

   return (
      <div className='w-11/12 m-auto my-6'>
         <h1 className="font-normal mb-8 text-3xl text-left">
            Kyzzen Academy Dashboard
         </h1>
         <div className="mt-0 mb-10 flex flex-row justify-between items-center sm:flex-row">

            <div className='flex items-center justify-center gap-2 capitalize'>
               <h1 className="font-extralight text-2xl text-left cursor-pointer" onClick={() => push(`/dashboard/course-categories/`)}>
                  {category.replaceAll('-', ' ')}
               </h1>
               <svg className="w-5 h-5  mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4" />
               </svg>
               <h1 className="font-extralight text-2xl text-left cursor-pointer" onClick={() => push({ pathname: `/dashboard/course-categories/category/sub-category`, state: state.categoryID })}>
                  {sub.replaceAll('-', ' ')}
               </h1>
               <svg className="w-5 h-5  mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4" />
               </svg>
               <h1 className="font-extralight text-2xl text-left">
                  Courses
               </h1>
            </div>
            <div className="w-full sm:w-auto flex items-center space-x-4">

               <div className="w-full sm:w-auto flex items-center space-x-4">
                  <BtnGradient>
                     <Link to={{ pathname: 'manage/', state: { categoryIds: state.categoryID, subCategoryIds: state.id } }}>
                        <Button
                           type="button"
                           className="w-auto btn bg-transparent text-white text-sm font-medium flex items-center gap-2"
                        >
                           Create New
                           <AddBox />
                        </Button>
                     </Link>
                  </BtnGradient>
               </div>

            </div>
         </div>
         <div>
            <InputField
               type="text"
               defaultValue={''}
               onChange={handleSearch}
               className="w-full  mb-1 mx-0 bg-gray-90 border-gray-80 rounded-full"
               placeholder="Search for course "
            />
         </div>
         <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId='featured'>
               {(provided) => (
                  <div
                     className=''
                     {...provided.droppableProps}
                     ref={provided.innerRef}
                  // style={getListStyle(snapshot.isDraggingOver)}
                  >
                     {
                        courses?.map((item: any, index: number) => (
                           <Draggable key={index} draggableId={item.id || index.toString()} index={index}>
                              {(provided) => (
                                 <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                 >
                                    <CourseCard key={1} data={item} getCourses={getCourses} />

                                 </div>
                              )}
                           </Draggable>
                        ))
                     }
                     {provided.placeholder}
                  </div>
               )}
            </Droppable>
         </DragDropContext>
         {courses.length < 1 && <p className='text-xl text-center'>No Courses Found...</p>}
      </div >
   )
}

export default Courses